// ================================================================
// documentsView — Rest-Modul nach der React-Migration der Dokumente-Ansicht
// ================================================================
// Die eigentliche Ansicht (Liste, Papierkorb, PDF-Vorschau, Nachweis-Dialog)
// lebt jetzt als React-Insel in react/components/documents/DocumentsView.tsx.
// Hier bleibt nur, was ANDERE Vanilla-Module weiterhin brauchen:
//   - loadDocuments/loadCustomers2 — Shell-Cache (s.docs/s.cust2List) für
//     Kunden-2-Ansicht, Dashboard und den Voice-Weg des Senden-Dialogs
//   - der generische Confirm-Dialog (askConfirm/…): settingsConnections und
//     die Dispatcher-Fälle confirm-yes/confirm-no hängen daran
// Muster wie die settings*-Module: KEIN eigener State — alles lebt weiter im
// geteilten `s` von CompanyDashboard; s/draw werden einmal via
// initDocumentsView() injiziert (vermeidet Import-Zyklen).
import { t } from '../../i18n/index.js';
import { escapeHtml } from '../../utils/dom.js';
import { listDocuments } from '../../core/documents.js';
import { listCustomersWithDocuments } from '../../core/customers.js';

let s;
let draw;

/** Einmal beim Modul-Start von CompanyDashboard aufrufen. */
export function initDocumentsView(ctx) {
  ({ s, draw } = ctx);
}

// Hält den Shell-Cache s.docs frisch (Voice-Senden-Dialog, Kunden 2).
// Zeichnet NUR noch für customers2 neu: die Dokumente-Ansicht ist eine
// React-Insel, die ihre Liste selbst holt — ein draw() dort würde die Insel
// bloss unnötig neu mounten.
export async function loadDocuments() {
  s.docsLoading = true; s.docsError = '';
  if (s.view === 'customers2') draw();
  try {
    const r = await listDocuments();
    s.docs = r.documents || [];
    s.docsLoaded = true;
  } catch (e) {
    s.docsError = e.message || t('common.loadFailed');
  } finally {
    s.docsLoading = false;
    if (s.view === 'customers2') draw();
  }
}

// ── Kunden 2: list-e moshtari-ha-ye dara-ye sanad ──
export async function loadCustomers2() {
  s.cust2Loading = true; s.cust2Error = '';
  if (s.view === 'customers2') draw();
  try {
    const r = await listCustomersWithDocuments();
    s.cust2List = r.customers || [];
    s.cust2Loaded = true;
  } catch (e) {
    s.cust2Error = e.message || t('common.loadFailed');
  } finally {
    s.cust2Loading = false;
    if (s.view === 'customers2') draw();
  }
}

// ── confirm modal (jaygozin-e window.confirm ba tam-e barnameh) ──
export function askConfirm(opts) {
  s.confirmModal = {
    title: opts.title || t('dashboard.confirm.defaultTitle'),
    message: opts.message || '',
    confirmLabel: opts.confirmLabel || t('dashboard.confirm.ok'),
    danger: !!opts.danger,
    onConfirm: opts.onConfirm || null,
  };
  draw();
}

export function closeConfirm() {
  s.confirmModal = null;
  draw();
}

export async function confirmYes() {
  const m = s.confirmModal;
  if (!m) return;
  const fn = m.onConfirm;
  s.confirmModal = null;
  draw();
  if (fn) await fn();
}

// modal-e taeed (confirm) ba tam-e barnameh — Overlay-Renderer, wird von
// draw() am Ende an den Container gehängt.
export function renderConfirmModal(container) {
  if (!s.confirmModal) return;
  const m = s.confirmModal;
  const cf = document.createElement('div');
  cf.className = 'cd-send-modal cd-confirm-modal';
  cf.innerHTML =
    '<div class="cd-send-backdrop" data-action="confirm-no"></div>' +
    '<div class="cd-send-card cd-confirm-card">' +
      '<div class="cd-confirm-body">' +
        '<div class="cd-confirm-title">' + escapeHtml(m.title) + '</div>' +
        '<div class="cd-confirm-msg">' + escapeHtml(m.message) + '</div>' +
      '</div>' +
      '<div class="cd-send-foot">' +
        '<button class="cd-btn-ghost" data-action="confirm-no">' + escapeHtml(t('common.cancel')) + '</button>' +
        '<button class="' + (m.danger ? 'cd-btn-primary cd-btn-danger-solid' : 'cd-btn-primary') + '" data-action="confirm-yes">' + escapeHtml(m.confirmLabel) + '</button>' +
      '</div>' +
    '</div>';
  container.appendChild(cf);
}
